<template>
	<div class=" grid-content content-margin">
		<div class="buttonarea" v-for="(item, index) in menuText" :key="item">
			<el-link :underline="false">
				<el-button size="large" round @click="onClick(index)">
					{{$t(`message.${item}`)}}
				</el-button>
			</el-link>
		</div>
	</div>
</template>

<script>
	export default {
		name: "OrgCommon",
		props: {
			menuText: Array,
		},
		data() {
			return {};
		},
		methods: {
			onClick(index) {
				this.$emit('clickButton', index);
			}
		},
		watch: {
			menuText: {
				handler(val, oldVal) {},
				deep: true,
				immediate: true,
			},
		},
	}
</script>

<style scoped>
.el-button{
	width:150px
}
</style>



// WEBPACK FOOTER //
// src/components/Organization/AddOrgType.vue